import * as React from 'react';
import { reduxForm } from 'redux-form';
import ViewEditForm, { ViewEditFormProps } from '../../../shared/Forms/ViewEditForm/ViewEditForm';
import { decimal, required } from '../../../shared/Forms/validations';

const SettlementOverviewForm = (props: ViewEditFormProps) => (
  <ViewEditForm
    {...props}
    fieldData={[
      {
        name: 'enrolledBalance',
        type: 'number',
        label: 'Enrolled Balance',
        fieldFormat: 'dollar',
        validate: [required]
      },
      {
        name: 'balanceAtSettlement',
        type: 'number',
        label: 'Balance at Settlement',
        fieldFormat: 'dollar',
        validate: [required]
      },
      {
        name: 'negotiatedAmount',
        type: 'number',
        label: 'Negotiated Balance',
        fieldFormat: 'dollar',
        validate: [required, decimal]
      },
      {
        name: 'balance',
        type: 'number',
        label: 'Remaining Balance',
        fieldFormat: 'dollar',
        validate: [required, decimal]
      },
      {
        name: 'settlementDate',
        type: 'date',
        label: 'Settlement Date',
        validate: [required]
      },
      {
        name: 'discountPercent',
        type: 'number',
        label: 'Discount %',
        fieldFormat: 'percentage',
        validate: [required]
      }
    ]}
  />
);

export default reduxForm<{}, { initialEditing: boolean }>({
  form: 'settlementOverviewForm'
})(SettlementOverviewForm);
